import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

// Facebook brand blue - used as default color
const FACEBOOK_BLUE = "#1877F2";

export default function FacebookLogo({
  outline,
  color = FACEBOOK_BLUE,
  ...props
}: IconProps): JSX.Element {
  return outline ? (
    <FacebookLogo.Outline color={color} {...props} />
  ) : (
    <FacebookLogo.Solid color={color} {...props} />
  );
}

FacebookLogo.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        {/**
         * Enter the contents of your SVG here without the <svg> tag.
         * For outlined icons, be sure to add `className="icon-outline"`
         * to each path that needs to be outlined.
         */}
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

FacebookLogo.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        <path
          d="M22 11.9999C22 6.47705 17.5229 1.9999 12 1.9999C6.47715 1.9999 2 6.47705 2 11.9999C2 16.9912 5.65686 21.1282 10.4375 21.8784V14.8905H7.89844V11.9999H10.4375V9.79678C10.4375 7.29053 11.9304 5.90615 14.2146 5.90615C15.3087 5.90615 16.4531 6.10147 16.4531 6.10147V8.5624H15.1921C13.9499 8.5624 13.5625 9.33324 13.5625 10.1241V11.9999H16.3359L15.8926 14.8905H13.5625V21.8784C18.3431 21.1282 22 16.9912 22 11.9999Z"
          fill="currentColor"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
